import type { Template } from "@/types";

export const LA_06_H1_V5: Template[] = [
    {
        id: "la-05-h1v5-01",
        name: "LA 01 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_01.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 133, y: 96, width: 202, height: 291, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 96, width: 201, height: 291, rotation: 0, imageRotation: 0 },
            { id: "4", x: 820, y: 35, width: 388, height: 230, rotation: 0, imageRotation: 0 },
            { id: "4", x: 820, y: 272, width: 124, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 952, y: 272, width: 124, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1084, y: 272, width: 124, height: 176, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-02",
        name: "LA 02 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 205, y: 48, width: 267, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 792, y: 48, width: 143, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 792, y: 245, width: 143, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 245, width: 143, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1094, y: 245, width: 142, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 943, y: 48, width: 293, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-03",
        name: "LA 03 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 192, y: 48, width: 142, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 48, width: 141, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 192, y: 254, width: 291, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 814, y: 48, width: 264, height: 386, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1086, y: 48, width: 128, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1086, y: 245, width: 128, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-04",
        name: "LA 04 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 145, y: 48, width: 386, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 145, y: 253, width: 124, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 277, y: 253, width: 123, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 408, y: 253, width: 123, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 802, y: 92, width: 208, height: 298, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 92, width: 207, height: 298, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-05",
        name: "LA 05 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 145, y: 48, width: 386, height: 243, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 145, y: 298, width: 91, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 244, y: 298, width: 91, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 298, width: 90, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 441, y: 298, width: 90, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 870, y: 48, width: 288, height: 387, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-06",
        name: "LA 06 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 82, y: 65, width: 512, height: 355, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 758, y: 65, width: 124, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 758, y: 246, width: 124, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 65, width: 252, height: 354, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1148, y: 65, width: 122, height: 173, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1148, y: 246, width: 122, height: 173, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-07",
        name: "LA 07 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_07.png",
        size: [1352, 483],
        style: {},
        slots: [          
            { id: "1", x: 134, y: 60, width: 125, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 134, y: 246, width: 125, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 267, y: 60, width: 125, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 267, y: 246, width: 125, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 400, y: 60, width: 566, height: 364, rotation: 0, imageRotation: 0 },
            { id: "6", x: 973, y: 60, width: 245, height: 364, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-08",
        name: "LA 08 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 75, width: 236, height: 334, rotation: 0, imageRotation: 0 },
            { id: "2", x: 243, y: 75, width: 236, height: 334, rotation: 0, imageRotation: 0 },
            { id: "3", x: 486, y: 75, width: 493, height: 334, rotation: 0, imageRotation: 0 },
            { id: "4", x: 987, y: 75, width: 236, height: 334, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1230, y: 75, width: 122, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1230, y: 246, width: 122, height: 163, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-09",
        name: "LA 09 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 134, y: 59, width: 126, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 134, y: 245, width: 126, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 268, y: 59, width: 565, height: 364, rotation: 0, imageRotation: 0 },
            { id: "4", x: 841, y: 59, width: 124, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 841, y: 245, width: 124, height: 178, rotation: 0, imageRotation: 0 },
            { id: "6", x: 973, y: 59, width: 245, height: 364, rotation: 0, imageRotation: 0 }
         
        ],
    },

    {
        id: "la-06-h1v5-10",
        name: "LA 10 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h1_v5_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 171, width: 187, height: 272, rotation: 0, imageRotation: 0 },
            { id: "2", x: 195, y: 171, width: 187, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 389, y: 171, width: 381, height: 272, rotation: 0, imageRotation: 0 },
            { id: "4", x: 778, y: 171, width: 187, height: 272, rotation: 0, imageRotation: 0 },
            { id: "5", x: 973, y: 171, width: 186, height: 272, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1167, y: 171, width: 186, height: 272, rotation: 0, imageRotation: 0 }         
        ],
    }
];